export default __webpack_public_path__ + "static/media/deleteNew.bfc5f577.svg";